import { Bell, Settings } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useStore } from '@/store'
import { getInitials } from '@/lib/utils'

export default function Header() {
  const user = useStore(state => state.user)
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-brand to-brand-dark flex items-center justify-center">
            <span className="text-white font-bold text-sm">C</span>
          </div>
          <span className="font-semibold text-lg">Capybank</span>
        </Link>
        
        {/* Actions */}
        <div className="flex items-center gap-3">
          <button className="relative p-2 rounded-xl hover:bg-background-elevated transition-colors">
            <Bell className="w-5 h-5 text-text-secondary" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-accent-red rounded-full" />
          </button>
          
          <Link 
            to="/settings"
            className="flex items-center gap-2 p-1 pr-3 rounded-full bg-background-elevated hover:bg-background-hover transition-colors"
          >
            {user?.avatar ? (
              <img 
                src={user.avatar} 
                alt={user.firstName}
                className="w-7 h-7 rounded-full"
              />
            ) : (
              <div className="w-7 h-7 rounded-full bg-brand/20 flex items-center justify-center">
                <span className="text-brand text-xs font-medium">
                  {getInitials(user?.firstName || 'U')}
                </span>
              </div>
            )}
            <Settings className="w-4 h-4 text-text-secondary" />
          </Link>
        </div>
      </div>
    </header>
  )
}